import RestApiModel from "@/api/Model/RestApiModel";

class Report extends RestApiModel {
  static getResourceEndpoint() {
    return '/reports';
  }
}

export default Report;
